/**
* @Name: Form Constants
* @Creation Date: July 31, 2017
* @Author: sbaireddy
* @Version: 1.0 :
*/
import { IKeyValue } from './modal/key.value'
import {
    ICreditOption, IRouteInfo, ITabInfo, IWCToken, IPackage, IPayment, IShipping, IFinance,
    IPromotion, IOrderList, INotification, IMoreInfoList
} from './modal/common';
import { Cart } from './modal/cart';
import { Customer } from './modal/customer';
import { ISubscriber, IOrder, ICreditLine } from './modal/common';
import * as Constants from '../shared/constants';

export let HEADER_BACKGROUND_DEFAULT = 'black';
export let SIDEBAR_BACKGROUND_DEFAULT = 'black';
export let SIDEBAR_ACTIVE_COLOR_DEFAULT = 'info';
export let CONTENT_BACKGROUND_DEFAULT = 'gray';

export const CREDIT_OPTIONS: ICreditOption[] = [
    {
        name: 'DEFAULT',
        description: '',
        creditType: 'DE',
        default: true,
        show: false
    }, {
        name: 'AWESOME CREDIT',
        description: 'I have stellar credit, with no significant issues.',
        creditType: 'AS',
        default: false,
        show: true
    }, {
        name: 'AVERAGE CREDIT',
        description: 'I have a pretty normal credit score. (Youâre not alone! Many of our customers have average credit).',
        creditType: 'CC',
        default: false,
        show: true
    }, {
        name: 'NO CREDIT CHECK',
        description: 'I do not want to run my credit.',
        creditType: 'NC',
        default: false,
        show: true
    }
];

export const SIDEBAR_ROUTES: IRouteInfo[] = [
    { path: '/home/search', title: 'Search', icon: 'ti-search', class: '' },
    { path: '/home/gsm-rateplans', title: 'Plans', icon: 'ti-bar-chart', class: '' },
    { path: '/home/gsm-devices', title: 'Devices', icon: 'ti-mobile', class: '' },
    { path: '/home/mi-rateplans', title: 'MI Plans', icon: 'ti-bar-chart-alt', class: '' },
    { path: '/home/mi-devices', title: 'MI Devices', icon: 'ti-tablet', class: '' },
    { path: '/home/features', title: 'Features', icon: 'ti-briefcase', class: '' },
    { path: '/home/accessories', title: 'Accessories', icon: 'ti-headphone', class: '' }
];

export const TOPBAR_ROUTER: IRouteInfo[] = [
    { path: '/home/coverage', title: 'Coverage', icon: 'ti-map', class: '' },
    { path: '/home/notes', title: 'Order Notes', icon: 'ti-notepad', class: '' },
    { path: '/home/customer', title: 'Customer Profile', icon: 'ti-user', class: '' },
    { path: '/home/clear', title: 'Clear', icon: 'ti-close', class: '' },
    { path: '/home/cart', title: 'Cart', icon: 'ti-shopping-cart', class: '' },
    { path: '/home/fullcart', title: 'Shopping Cart', icon: 'ti-shopping-cart-full', class: '' },
    { path: '/checkout/customer-info', title: 'Secure Checkout', icon: 'ti-shopping-cart-full', class: '' },
    { path: '/checkout/pay-review', title: 'Secure Checkout', icon: 'ti-shopping-cart-full', class: '' },
    { path: '/checkout/confirm', title: 'Secure Checkout', icon: 'ti-shopping-cart-full', class: '' },
    { path: '/estimate/template-info', title: 'Purchase Estimate', icon: 'ti-shopping-cart-full', class: '' },    
    { path: '/estimate/email-confirm', title: 'Email Confirm', icon: 'ti-shopping-cart-full', class: '' }
];

export const SORT_BY_OPTIONS: IKeyValue[] = [
    { key: 'price-asc', value: 'Price - low to high' },
    { key: 'price-desc', value: 'Price - high to low' },
    { key: 'name-asc', value: 'Name - A to Z' },
    { key: 'name-desc', value: 'Name - Z to A' }
];

export const RATEPLAN_MOREINFO: ITabInfo[] = [
    { path: 'tab1', key: 'planDetails', title: 'Plan Details', class: 'active' },
    { path: 'tab2', key: 'planFeatures', title: 'Plan Features', class: '' },
    { path: 'tab3', key: 'termsFees', title: 'Terms Fees', class: '' },
    { path: 'tab4', key: 'includedFeatures', title: 'Included Features', class: '' },
    { path: 'tab5', key: 'optionalFeatures', title: 'Optional Features', class: '' },
];
export const DEVICE_MOREINFO: ITabInfo[] = [
    { path: 'tab1', key: 'overview', title: 'Overview', class: 'active' },
    { path: 'tab2', key: 'features', title: 'Features', class: '' },
    { path: 'tab3', key: 'relatedAccessories', title: 'Related Accessories', class: '' }
];
export const FEATURE_MOREINFO: ITabInfo[] = [
    { path: 'tab1', key: 'overview', title: 'Overview', class: 'active' },
    { path: 'tab2', key: 'feature', title: 'Features', class: '' },
    { path: 'tab3', key: 'relatedAccessories', title: 'Related Accessories', class: '' },
    { path: 'tab4', key: 'featureOverview', title: 'Feature Overview', class: '' }
];
export const ACCESSORY_MOREINFO: ITabInfo[] = [
    { path: 'tab1', key: 'overview', title: 'Overview', class: 'active' },
    { path: 'tab2', key: 'compatibility', title: 'Compatibility', class: '' },
    { path: 'tab3', key: 'features', title: 'Features', class: '' }
];

export const ORDER_NOTES_REASONS: IKeyValue[] = [
    { key: 'Order Review', value: 'Order Review' },
    { key: 'Inbound Call', value: 'Inbound Call' },
    { key: 'Outbound Call', value: 'Outbound Call' },
    { key: 'WTS', value: 'WTS' },
    { key: 'Coach Review', value: 'Coach Review' },
    { key: 'QA Review', value: 'QA Review' },
    { key: 'Do Not Call', value: 'Do Not Call' },
    { key: 'Other', value: 'Other' },
];


export const TRADE_IN_ACCOUNTS: IKeyValue[] = [
    { key: 'accountSubType_Q', value: 'Q' },
    { key: 'accountSubType_R', value: 'R' },
    { key: 'accountSubType_M', value: 'M' },
    { key: 'accountType', value: 'I' },

];


export const ADJUST_PRICE_REASONS: IKeyValue[] = [
    { key: 'Rekey: pricing changed', value: 'Rekey: pricing changed' },
    { key: 'Sales Concession', value: 'Sales Concession' }
];

export const RT_ADJUST_PRICE_SOFTGOODS_REASONS: IKeyValue[] = [
    { key: 'Offer/promotion', value: 'Offer/promotion' },
    { key: 'Manager Directed', value: 'Manager Directed' }
];

export const RT_ADJUST_PRICE_HARGOODS_REASONS: IKeyValue[] = [
    { key: 'Offer/Promotion', value: 'Offer/Promotion' },
    { key: 'BOGO', value: 'BOGO' },
    { key: 'Accessory Offer', value: 'Accessory Offer' },
    { key: 'Signature Offer', value: 'Signature Offer' },
    { key: 'Manager Directed', value: 'Manager Directed' },
    { key: 'Customer Escalation', value: 'Customer Escalation' },
    { key: 'List Price Incorrect', value: 'List Price Incorrect' },
    { key: 'Competition Price Match', value: 'Competition Price Match' },
    { key: 'SIM Card', value: 'SIM Card' },
    { key: 'Direct Mail Offer', value: 'Direct Mail Offer' },
    { key: 'Employee Discount Program', value: 'Employee Discount Program' },
    { key: '1 Year Contract Price', value: '1 Year Contract Price' },
];

export const ISSUE_CREDIT_REASONS: IKeyValue[] = [
    { key: 'W15', value: 'Missed shipping delivery' },
    { key: 'W16', value: 'Wrong device/accessory shipped' },
    { key: 'W17', value: 'Returned device/accessory not credited' },
    { key: 'W18', value: 'Did not receive device/accessory' }
];

export const RETURN_ITEM_REASONS: IKeyValue[] = [
    { key: 'W01', value: 'WSC: Pre-Orders Only' },
    { key: 'W02', value: 'Does not meet needs' },
    { key: 'W03', value: 'Not what expected' },
    { key: 'W04', value: 'Difficult to use' },
    { key: 'W05', value: 'Changed mind' },
    { key: 'W06', value: 'Device DOA' },
    { key: 'W07', value: 'Device damaged' },
    { key: 'W08', value: 'Received too late' },
    { key: 'W09', value: 'Wrong device rec d' },
    { key: 'W10', value: 'Unknown' },
    { key: 'W11', value: 'Damage' },
    { key: 'W12', value: 'Cust claims not rec d' },
    { key: 'W13', value: 'Delv d/missing Merch' },
    { key: 'W14', value: 'Undeliverable' },
];

export const INVENTORY_STATUS: IKeyValue[] = [
    { key: 'INS', value: 'In Stock' },
    { key: 'PRE', value: 'Preorder' },
    { key: 'BOA', value: 'Backorder' },
    { key: 'OOS', value: 'Out of stock' },
];

export const PAYMENT_METHODS: IKeyValue[] = [
    { key: 'CREDIT',    value: 'Credit Card' },
    { key: 'WEBPAYMENT', value: 'Web Payment ID' }
];

export const CARD_TYPES: IKeyValue[] = [
    { key: 'VISA',          value: 'Visa' },
    { key: 'MASTERCARD',    value: 'Master' },
    { key: 'AMERICANEXPRESS', value: 'Amex' },
    { key: 'DISCOVER',          value: 'Discover' },
    { key: 'DINER',         value: 'DINER' }
];

export const STORES: IKeyValue[] = [
    { key: Constants.STORE_ID_TMO_STR, value: 'T-Mobile.com' },
    { key: Constants.STORE_ID_MYTMO_STR, value: 'My TMobile.com' },
    { key: Constants.STORE_ID_CD_STR, value: 'Consumer Direct Telesales' },
    { key: Constants.STORE_ID_BD_STR, value: 'Business Direct Telesales' },
    { key: Constants.STORE_ID_CS_STR, value: 'Customer Service Care' },    
    { key: Constants.STORE_ID_RT_STR, value: 'Retail' }
];

export const STORES_SHORT: IKeyValue[] = [
    { key: Constants.STORE_ID_TMO_STR, value: 'TMO' },
    { key: Constants.STORE_ID_MYTMO_STR, value: 'MYT' },
    { key: Constants.STORE_ID_CD_STR, value: 'CD' },
    { key: Constants.STORE_ID_BD_STR, value: 'BD' },
    { key: Constants.STORE_ID_CS_STR, value: 'CS' },
    { key: Constants.STORE_ID_RT_STR, value: 'RT' }
];

export const CHANNELS: IKeyValue[] = [
    { key: Constants.STORE_ID_TMO_STR, value: 'T-Mobile.com' },
    { key: Constants.STORE_ID_MYTMO_STR, value: 'My TMobile.com' },
    { key: Constants.STORE_ID_CD_STR, value: 'Consumer Direct Telesales' },
    { key: Constants.STORE_ID_BD_STR, value: 'Business Direct Telesales' },
    { key: Constants.CHANNEL_LEGACYQV, value: 'QVConsumer Direct' },
    { key: Constants.CHANNEL_TIC, value: 'Customer Service Care' },
    { key: Constants.STORE_ID_RT_STR, value: 'Retail' }
];

export const ORDER_REFTYPE: IKeyValue[] = [
    { key: 'new', value: 'New' },
    { key: 'exchange', value: 'Exchange' },
    { key: 'return', value: 'Return' },
    { key: 'credit', value: 'Credit' }
];

export const ORDER_SEARCH_REFTYPE: IKeyValue[] = [
    { key: 'NEW_ORDER_TYPE', value: 'New' },
    { key: 'EXCHANGE_ORDER_TYPE', value: 'Exchange' },
    { key: 'RETURN_ORDER_TYPE', value: 'Return' },
    { key: 'CREDIT_ORDER_TYPE', value: 'Credit' }
];

export const ORDER_STATUS: IKeyValue[] = [
    { key: 'P', value: 'Work in Progress' },
    { key: 'P1', value: 'Manual Review' },
    { key: 'P2', value: 'Order Verification' },
    { key: 'P3', value: 'SAP Submit Hold' },
    { key: 'P4', value: 'Processing Error' },
    { key: 'P5', value: 'SAP Reject' },
    { key: 'P6', value: 'EIP Pending' },
    { key: 'P7', value: 'EIP Cancelled' },
    { key: 'P8', value: 'CC Fraud Failed' },
    { key: 'P9', value: 'TIBCO Unavailable' },
    { key: 'P10', value: 'Submitted(Order Queued)' },
    { key: 'P11', value: 'Vesta Token Fail' },
    { key: 'P12', value: 'Fraud Esig Invocation' },
    { key: 'P13', value: 'Finance Mixed Queued' },
    { key: 'P14', value: 'Tradein Quote Expired' },
    { key: 'P15', value: 'Activation Failed' },
    { key: 'P16', value: 'Settlement Failed' },
    { key: 'P17', value: 'Fraud Reject' },
    { key: 'P18', value: 'Fraud Review' },
    { key: 'P19', value: 'Fraud Check Failed' },
    { key: 'P20', value: 'CC Authorization Failure' },
    { key: 'P21', value: 'EIP Disclosure error' },
    { key: 'z', value: 'Canceled (SAP)' },
    { key: 'cr', value: 'Credited' },
    { key: 'CR', value: 'Credited' },
    { key: 'C', value: 'Submitted' },
    { key: 'DC', value: 'SAP CC Decline' },
    { key: 'X', value: 'Canceled' },
    { key: 'S', value: 'Shipped' },
    { key: 'PS', value: 'Partially Shipped' },
    { key: 'B', value: 'Backordered' },
    { key: 'B1', value: 'Partially Shipped' },
    { key: 'r', value: 'Returned' },
    { key: 'L', value: 'Preorder' },
    { key: 'ACTIVATION FAILED', value: 'Activation Failed' }
];

export const ORDER_STATUS_DROP_DOWN_LIST: IKeyValue[] = [
    { key: 'P', value: 'Work in Progress' },
    { key: 'P1', value: 'Manual Review' },
    { key: 'P2', value: 'Order Verification' },
    { key: 'P3', value: 'SAP Submit Hold' },
    { key: 'P4', value: 'Processing Error' },
    { key: 'P5', value: 'SAP Reject' },
    { key: 'P6', value: 'eSignature Pending' },
    { key: 'P7', value: 'eSignature Expired' },
    { key: 'P14', value: 'EIP Disclosure error' },
    { key: 'P8', value: 'CC Authorization Failure' },
    { key: 'P10', value: 'Submitted(Order Queued)' },
    { key: 'P11', value: 'Mixed Cart - WIP' },
    { key: 'X', value: 'Canceled' },
    { key: 'C', value: 'Submitted' },
    { key: 'DC', value: 'SAP CC Decline' },
    { key: 'S', value: 'Shipped' },    
    { key: 'PES', value: 'Purchase Est Sent' }
];

export const ID_TYPE: IKeyValue[] = [
    { key: 'DL', value: 'Drivers license' },
    { key: 'ID', value: 'State issued ID' },
    { key: 'MILI', value: 'Military ID' },
    { key: 'OTHER', value: 'Mexican matricula ID' },
    { key: 'PASS', value: 'Passport' },
    { key: 'DISA', value: 'Federally issued disability ID' },
    { key: 'ALIE', value: 'US issued alien ID' },
];

export const MONTHS: IKeyValue[] = [
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' }
];

export const STATES: IKeyValue[] = [
    { key: 'AL', value: 'Alabama' },
    { key: 'AK', value: 'Alaska' },
    { key: 'AZ', value: 'Arizona' },
    { key: 'AR', value: 'Arkansas' },
    { key: 'CA', value: 'California' },
    { key: 'CO', value: 'Colorado' },
    { key: 'CT', value: 'Connecticut' },
    { key: 'DE', value: 'Delaware' },
    { key: 'DC', value: 'District Of Columbia' },
    { key: 'FL', value: 'Florida' },
    { key: 'GA', value: 'Georgia' },
    { key: 'HI', value: 'Hawaii' },
    { key: 'ID', value: 'Idaho' },
    { key: 'IL', value: 'Illinois' },
    { key: 'IN', value: 'Indiana' },
    { key: 'IA', value: 'Iowa' },
    { key: 'KS', value: 'Kansas' },
    { key: 'KY', value: 'Kentucky' },
    { key: 'LA', value: 'Louisiana' },
    { key: 'ME', value: 'Maine' },
    { key: 'MD', value: 'Maryland' },
    { key: 'MA', value: 'Massachusetts' },
    { key: 'MI', value: 'Michigan' },
    { key: 'MN', value: 'Minnesota' },
    { key: 'MS', value: 'Mississippi' },
    { key: 'MO', value: 'Missouri' },
    { key: 'MT', value: 'Montana' },
    { key: 'NE', value: 'Nebraska' },
    { key: 'NV', value: 'Nevada' },
    { key: 'NH', value: 'New Hampshire' },
    { key: 'NJ', value: 'New Jersey' },
    { key: 'NM', value: 'New Mexico' },
    { key: 'NY', value: 'New York' },
    { key: 'NC', value: 'North Carolina' },
    { key: 'ND', value: 'North Dakota' },
    { key: 'OH', value: 'Ohio' },
    { key: 'OK', value: 'Oklahoma' },
    { key: 'OR', value: 'Oregon' },
    { key: 'PA', value: 'Pennsylvania' },
    { key: 'RI', value: 'Rhode Island' },
    { key: 'SC', value: 'South Carolina' },
    { key: 'SD', value: 'South Dakota' },
    { key: 'TN', value: 'Tennessee' },
    { key: 'TX', value: 'Texas' },
    { key: 'UT', value: 'Utah' },
    { key: 'VT', value: 'Vermont' },
    { key: 'VA', value: 'Virginia' },
    { key: 'WA', value: 'Washington' },
    { key: 'WV', value: 'West Virginia' },
    { key: 'WI', value: 'Wisconsin' },
    { key: 'WY', value: 'Wyoming' },
];

export const STATE_TAXES: IKeyValue[] = [
    { key: 'AL', value: '0.04' },
    { key: 'AK', value: '0.00' },
    { key: 'AZ', value: '0.056' },
    { key: 'AR', value: '0.065' },
    { key: 'CA', value: '7.250' },
    { key: 'CO', value: '0.029' },
    { key: 'CT', value: '6.350' },
    { key: 'DE', value: '0.000' },
    { key: 'DC', value: '0.0575' },
    { key: 'FL', value: '6.000' },
    { key: 'GA', value: '4.000' },
    { key: 'HI', value: '4.000' },
    { key: 'ID', value: '0.06' },
    { key: 'IL', value: '6.250' },
    { key: 'IN', value: '0.07' },
    { key: 'IA', value: '0.06' },
    { key: 'KS', value: '6.500' },
    { key: 'KY', value: '0.06' },
    { key: 'LA', value: '5.000' },
    { key: 'ME', value: '5.500' },
    { key: 'MD', value: '0.06' },
    { key: 'MA', value: '0.0625' },
    { key: 'MI', value: '6.000' },
    { key: 'MN', value: '6.875' },
    { key: 'MS', value: '7.000' },
    { key: 'MO', value: '0.04225' },
    { key: 'MT', value: '0.00' },
    { key: 'NE', value: '0.055' },
    { key: 'NV', value: '6.85' },
    { key: 'NH', value: '0.00' },
    { key: 'NJ', value: '0.06875' },
    { key: 'NM', value: '0.05125' },
    { key: 'NY', value: '0.04' },
    { key: 'NC', value: '4.750' },
    { key: 'ND', value: '5.000' },
    { key: 'OH', value: '0.0575' },
    { key: 'OK', value: '0.045' },
    { key: 'OR', value: '0.00' },
    { key: 'PA', value: '0.06' },
    { key: 'RI', value: '0.07' },
    { key: 'SC', value: '6.000' },
    { key: 'SD', value: '4.500' },
    { key: 'TN', value: '7.000' },
    { key: 'TX', value: '0.0625' },
    { key: 'UT', value: '4.700' },
    { key: 'VT', value: '6.000' },
    { key: 'VA', value: '4.300' },
    { key: 'WA', value: '0.065' },
    { key: 'WV', value: '0.06' },
    { key: 'WI', value: '0.05' },
    { key: 'WY', value: '4.000' }
];

// US267571: created a new ID States const that includes Puerto Rico to be used only for CC/NCC.
export const ID_STATES: IKeyValue[] = [
    { key: 'AL', value: 'Alabama' },
    { key: 'AK', value: 'Alaska' },
    { key: 'AZ', value: 'Arizona' },
    { key: 'AR', value: 'Arkansas' },
    { key: 'CA', value: 'California' },
    { key: 'CO', value: 'Colorado' },
    { key: 'CT', value: 'Connecticut' },
    { key: 'DE', value: 'Delaware' },
    { key: 'DC', value: 'District Of Columbia' },
    { key: 'FL', value: 'Florida' },
    { key: 'GA', value: 'Georgia' },
    { key: 'HI', value: 'Hawaii' },
    { key: 'ID', value: 'Idaho' },
    { key: 'IL', value: 'Illinois' },
    { key: 'IN', value: 'Indiana' },
    { key: 'IA', value: 'Iowa' },
    { key: 'KS', value: 'Kansas' },
    { key: 'KY', value: 'Kentucky' },
    { key: 'LA', value: 'Louisiana' },
    { key: 'ME', value: 'Maine' },
    { key: 'MD', value: 'Maryland' },
    { key: 'MA', value: 'Massachusetts' },
    { key: 'MI', value: 'Michigan' },
    { key: 'MN', value: 'Minnesota' },
    { key: 'MS', value: 'Mississippi' },
    { key: 'MO', value: 'Missouri' },
    { key: 'MT', value: 'Montana' },
    { key: 'NE', value: 'Nebraska' },
    { key: 'NV', value: 'Nevada' },
    { key: 'NH', value: 'New Hampshire' },
    { key: 'NJ', value: 'New Jersey' },
    { key: 'NM', value: 'New Mexico' },
    { key: 'NY', value: 'New York' },
    { key: 'NC', value: 'North Carolina' },
    { key: 'ND', value: 'North Dakota' },
    { key: 'OH', value: 'Ohio' },
    { key: 'OK', value: 'Oklahoma' },
    { key: 'OR', value: 'Oregon' },
    { key: 'PA', value: 'Pennsylvania' },
    { key: 'PR', value: 'Puerto Rico' },
    { key: 'RI', value: 'Rhode Island' },
    { key: 'SC', value: 'South Carolina' },
    { key: 'SD', value: 'South Dakota' },
    { key: 'TN', value: 'Tennessee' },
    { key: 'TX', value: 'Texas' },
    { key: 'UT', value: 'Utah' },
    { key: 'VT', value: 'Vermont' },
    { key: 'VA', value: 'Virginia' },
    { key: 'WA', value: 'Washington' },
    { key: 'WV', value: 'West Virginia' },
    { key: 'WI', value: 'Wisconsin' },
    { key: 'WY', value: 'Wyoming' },
];

export const monthRef = [
    { month: 1, days: 31 },
    { month: 2, days: 28 },
    { month: 3, days: 31 },
    { month: 4, days: 30 },
    { month: 5, days: 31 },
    { month: 6, days: 30 },
    { month: 7, days: 31 },
    { month: 8, days: 31 },
    { month: 9, days: 30 },
    { month: 10, days: 31 },
    { month: 11, days: 30 },
    { month: 12, days: 31 }
];

export const ORDER_NOTE_REASON: IKeyValue[] = [
    { key: 'CUSTOMER_CHANGED_MIND', value: 'Customer changed mind' },
    { key: 'CUSTOMER_REFERRED_TO_RETAIL', value: 'Customer referred to retail' },
    { key: 'NO_CREDIT_CARD_AVAILABLE', value: 'No Credit Card Available' },
    { key: 'WTS_REKEY', value: 'WTS:  Rekey' }
];

export const BYPASS_REASONS: IKeyValue[] = [
    { key: 'Order Rekey', value: 'Order Rekey' },
    { key: 'Order Troubleshooting', value: 'Order Troubleshooting' },
    { key: 'QA Bypass', value: 'QA Bypass' },
];

export const FEEDBACK_REASONS: IKeyValue[] = [
    { key: 'FR1', value: 'What do you like the most about our website?' },
    { key: 'FR2', value: 'What would you like to change on our website?' },
    { key: 'FR3', value: 'How easy is it to find what you are looking for?' },
    { key: 'FR4', value: 'Quick question: do you prefer the old or new design?' },
    { key: 'FR5', value: 'What was the first impression when you entered the website?' },
    { key: 'FR6', value: 'How clear is our website?' },
    { key: 'FR7', value: 'How can we improve our website?' },
    { key: 'FR8', value: 'Is there anything missing on this page?' },
    { key: 'FR9', value: 'How about overall website performance?' },
    { key: 'FR10', value: 'Other' },
];

export const TEMPLATE_TYPES: IKeyValue[] = [
    { key: 'MILITARY', value: 'Military' },
    { key: 'ESSENTIALS', value: 'Essentials' },
    { key: 'OTHER', value: 'Consumer' }
];

export const CUSTOMER_INTENT: IKeyValue[] = [
    { key: 'PURCHASED', value: 'Purchased' },
    { key: 'NOT PURCHASED', value: 'Still thinking about it' },    
    { key: 'BASE', value: 'Already With US' }
];


export const alertErrorKeys = [
    '_ERR_AUTHENTICATION_ERROR',
    '_ERR_ORDER_PORTIN_ELIGIBILITY_CHECK_FAILED',
    '_ERR_ORDER_CREATE_PORTIN_FAILED',
    '_ERR_ORDER_DELETE_PORTIN_FAILED',
    '_ERR_ORDER_CREDIT_CHECK_ALREADY_DONE',
    '_ERR_ORDER_NO_PORTIN_ENTRY_EXISTS',
    '_ERR_ORDER_CREDIT_CHECK_NOT_DONE',
    '_ERR_PROMOTION_CODE_DUPLICATED',
    '_ERR_PROMOTION_CODE_INVALID',
    '_ERR_EMPTY_CART',
    '_ERR_CART_IN_PROGRESS',
    '_ERR_SWITCH_CHANNEL',
    '_REVIEW_TERMS_CONDITIONS',
    '_ERR_ACCESSORY_COPY',
    '_MISSING_REVIEW_EMAIL',
    '_ERR_ORDER_ITEM_ADD_FAILED',
    '_ERR_NOT_HEXADECIMAL',
    '_E911_ADDRESS_DISCLAIMER',
    '_ERR_EQUIPMENT_EMAILS_SHOULD_ENTER',
    '_ERR_EQUIPMENT_EMAILS_ARE_NOT_SAME',
    '_ERR_CLEAR_SESSION',
    '_ERR_ORDER_NOTES',
    '_ERR_INVAID_SIM_LENGTH',
    '_ERR_NON_BYOS_ITEMS_IN_CART',
    '_ERR_BYOS_ONLY_ORDER',
    '_DEVICE_MISSING_IN_PACKAGE',
    '_DEVICE_MISSING_IN_INDIVIDUAL_PLAN',
    '_PLAN_MISSING_IN_INDIVIDUAL_PLAN',
    '_INSUFFICIENT_MIN_LINES',
    '_NO_ACCESSORIES_PRESENT',
    '_ORDER_HAS_MANUAL_BLOCK',
    '_ORDER_HAS_NO_PACKAGES',
    '_CREDIT_CHECK_NOT_COMPLETED',
    '_NOT_WITHIN_MINIMUM_EIP_ACCESSORY_PURCHASE_AMT_LIMIT',
    '_EXCHANGE_ITEM_MISSING_IN_PACKAGE',
    '_DUPICATE_ITEM_MAPPING_MISSING_IN_PACKAGE',
    '_CONFLICT_ITEM_ACC',
    '_CONFLICT_ITEM_DEVICE',
    '_CONFLICT_ITEM',
    '_MISSING_ADDRESS_FIELDS',
    '_MISSING_CARD_DETAILS',
    '_MISSING_OTP_VERIFICATION',
    '_ERR_ADJUST_REASON_EMPTY',
    '_ERR_ADJUST_PRICE_EMPTY',
    '_ERR_ADJUST_PRICE_INVALID',
    '_ERR_ACCOUNT_PASSWORD_NOT_MATCH',
    '_ERR_NO_PIN_SETUP',
    '_VALIDATEDEALER_ERROR_CODE_2009',
    'VALIDATEDEALER_ERROR_CODE_2009',
    '_INPUT_ERROR_CODE_2011',
    '_ERR_INVAID_CART',
    '_DBG_API_DO_PAYMENT_BAD_XDATE',
    '_ERR_RULES_SYSTEM',
    '_ERR_PROMOTION_NOT_AVAILABLE_AT_THIS_TIME',
    '_API_BAD_INV',
    '_ERR_INCOMPATIBLE_ITEM_IN_PACKAGE',
    '_ERR_EMAIL_NO_FOUND',
    '_ERR_NON_PERMISSIONED_AGENT',
    '_ERR_SOLE_PROPRIETOR',
    '_ERR_CUSTOMER_CREDIT_CHECK_ALREADY_DONE',
    'DISCOURAGE_PUERTO_RICO_CUSTOMERS',
    '_ERR_ERROR_ECALIMIT'
];


export let SHIPPING_COST: string = 'Free';
export let ELIGIBLE_FOR_R_AND_E: string = 'Eligible for Return & Exchange';
export let ELIGIBLE_FOR_R: string = 'Eligible for Return';
export let ELIGIBLE_FOR_E: string = 'Eligible for Exchange';
export let ITEM_ALREADY_RETURNED: string = 'A return has already been created for this item';
export let ITEM_ALREADY_RETURNED_CREDITED: string = 'This item has already been returned and credited';
export let ITEM_ALREADY_CREDITED: string = 'This item has been credited';
export let NOT_ELIGIBLE_FOR_R: string = ', Not Eligible for Return';
export let NOT_ELIGIBLE_FOR_E: string = ', Not Eligible for Exchange';
export let ADDITIONAL_LINE_FEE: string = 'Additional Line Fee';
export let FEES: string = 'Fees';
export let DEPOSIT: string = 'Deposit';
export let ACCOUNT_VERIFICATION: string = 'Account Verification';
export let DESCRIPTION_SUCCESS: string = 'User verified the SSN / PIN';
export let DESCRIPTION_FAILURE: string = 'User failed to verify the SSN / PIN';
export let FOOTPRINT: string = 'Footprint';
export let ORDER_ACCESSED: string = 'Order Accessed';
export let ORDER_CANCELLATION: string = 'Order Cancellation';
export let CANCELLATION_REASON: string = 'Cancellation Reason:';
export let ADDITIONAL_NOTES: string = ' Additional Notes: ';
export let NOT_ELIGIBLE_ISSUE_CREDIT: string = 'This item has already been credited';
export let ELIGIBLE_ISSUE_CREDIT: string = 'Eligible for Issue Credit';
export let NOT_ELIGIBLE_FOR_REFUND: string = 'This item has already been credited';
export let PERMISSION_LIMIT: string = 'This item exceeds your permissions to credit. For further assistance, please contact your supervisor';
